<template>
	
	<v-dialog
	    v-model="visible"
	    width="600"
		class="edit-dialog ma-0 pa-0"
		ref="editDialog"
		eager
	>
		<v-card>
			<v-card-title class="text-subtitle-1 white--text info" color="darkseagreen" ref="editDialogTitle">
				{{title}}
			</v-card-title>
			<v-card-text  class="mx-0 px-0 my-1" style="max-height:500px;overflow-y:auto;">
				<div class="d-flex flex-column">	
                    <div class="d-flex flex-column" v-if="mode==1">
                        <div class="form-item form-item-width-2 pt-2 ma-0">
                            <label class="form-item-label py-0 mt-0 mr-0">上级部门代码:</label>
                            <v-text-field 
                                class="form-item-value py-0 mr-0 readonly_input_item" 								
                                outlined
                                dense
                                placeholder=""
                                readonly							
                                v-model="parentDepartment.code"
                            >
                            </v-text-field>						
                        </div>

                        <div class="form-item form-item-width-2 pt-2 ma-0">
                            <label class="form-item-label py-0 mt-0 mr-0">上级部门名称:</label>
                            <v-text-field 
                                class="form-item-value py-0 mr-0 readonly_input_item" 								
                                outlined
                                dense
                                placeholder=""
                                readonly							
                                v-model="parentDepartment.name"
                            >
                            </v-text-field>						
                        </div>
                    </div>

                    <div class="d-flex flex-column" v-if="mode==2">
                        <div class="form-item form-item-width-2 pt-2 ma-0">
                            <label class="form-item-label py-0 mt-0 mr-0">同级部门代码:</label>
                            <v-text-field 
                                class="form-item-value py-0 mr-0 readonly_input_item" 								
                                outlined
                                dense
                                placeholder=""
                                readonly							
                                v-model="brotherDepartment.code"
                            >
                            </v-text-field>						
                        </div>

                        <div class="form-item form-item-width-2 pt-2 ma-0">
                            <label class="form-item-label py-0 mt-0 mr-0">同级部门名称:</label>
                            <v-text-field 
                                class="form-item-value py-0 mr-0 readonly_input_item" 								
                                outlined
                                dense
                                placeholder=""
                                readonly							
                                v-model="brotherDepartment.name"
                            >
                            </v-text-field>						
                        </div>
                    </div>

                    <v-divider class="my-1" v-if="(mode==1 || mode==2)"/>

                    <div class="form-item form-item-width-1 pt-2 ma-0">
                        <label class="form-item-label py-0 mt-0 mr-0">部门编号:</label>
    
                        <v-text-field 
                            class="form-item-value py-0 mr-0 readonly_input_item" 								
                            outlined
                            dense
                            placeholder=""
                            readonly							
                            v-model="editingDepartment.id"
                        >
                        </v-text-field>			
                    </div>

                    <div class="form-item form-item-width-2 pt-2 ma-0">
                        <label class="form-item-label py-0 mt-0 mr-0">部门代码:</label>
                        <v-text-field
                            class="form-item-value py-0 mr-0" 	
                            :class="{readonly_input_item:codeDisabled}"
                            v-model="editingDepartment.code"					
                            outlined
                            dense
                            placeholder=""							
                        >
                        </v-text-field>					
                    </div>

                    <div class="form-item form-item-width-2 pt-2 ma-0">
                        <label class="form-item-label py-0 mt-0 mr-0">部门名称:</label>
                        <v-text-field
                            class="form-item-value py-0 mr-0" 	
                            :class="{readonly_input_item:nameDisabled}"
                            v-model="editingDepartment.name"					
                            outlined
                            dense
                            placeholder=""							
                        >
                        </v-text-field>					
                    </div>

                    <div class="form-item form-item-width-1 pt-2 ma-0">
                        <label class="form-item-label py-0 mt-0 mr-0">默认部门:</label>
                        <v-select
                            class="form-item-value py-0 mr-0" 	
                            v-model="editingDepartment.defaultFlag"
                            :class="{readonly_input_item:defaultFlagDisabled}"
                            :items="defaultFlags"						
                            label=""
                            hide-details											
                            flat
                            solo
                            outlined
                            dense						                            
                            item-text="caption"
                            item-value="id"
                            full-width	
                            :background-color="getSelectorBackgroundColor(defaultFlagDisabled)"					
                        >
                        </v-select>					
                    </div>

                    <div class="form-item form-item-width-1 pt-2 ma-0">
                        <label class="form-item-label py-0 mt-0 mr-0">末级部门:</label>
                        <v-select
                            class="form-item-value py-0 mr-0" 	
                            v-model="editingDepartment.leafFlag"
                            :class="{readonly_input_item:leafFlagDisabled}"
                            :items="leafFlags"						
                            label=""
                            hide-details											
                            flat
                            solo
                            outlined
                            dense						                            
                            item-text="caption"
                            item-value="id"
                            full-width		
                            :background-color="getSelectorBackgroundColor(leafFlagDisabled)"			
                        >
                        </v-select>					
                    </div>

                    <div class="form-item form-item-width-1 pt-2 ma-0">
                        <label class="form-item-label py-0 mt-0 mr-0">状态:</label>
                        <v-select
                            class="form-item-value py-0 mr-0" 	
                            v-model="editingDepartment.status"
                            :class="{readonly_input_item:statusDisabled}"
                            :items="statusFlags"						
                            label=""
                            hide-details											
                            flat
                            solo
                            outlined
                            dense						                            
                            item-text="caption"
                            item-value="id"
                            full-width
                            :background-color="getSelectorBackgroundColor(statusDisabled)"						
                        >
                        </v-select>					
                    </div>

                    <div class="form-item form-item-width-1 pt-2 ma-0">
                        <label class="form-item-label py-0 mt-0 mr-0">营运部门:</label>
                        <v-select
                            class="form-item-value py-0 mr-0" 	
                            v-model="editingDepartment.operationFlag"
                            :class="{readonly_input_item:operationFlagDisabled}"
                            :items="operationFlags"						
                            label=""
                            hide-details											
                            flat
                            solo
                            outlined
                            dense						                            
                            item-text="caption"
                            item-value="id"
                            full-width
                            :background-color="getSelectorBackgroundColor(operationFlagDisabled)"						
                        >
                        </v-select>					
                    </div>

                    <div class="form-item form-item-width-2 pt-2 ma-0">
                        <label class="form-item-label py-0 mt-0 mr-0">对应组织:</label>
                        <v-select
                            class="form-item-value py-0 mr-0" 	
                            v-model="editingDepartment.orgId"
                            :class="{readonly_input_item:orgIdDisabled}"
                            :items="orgs"						
                            label=""
                            hide-details											
                            flat
                            solo
                            outlined
                            dense						                            
                            item-text="name"
                            item-value="id"
                            full-width		
                            :background-color="getSelectorBackgroundColor(orgIdDisabled)"				
                        >
                        </v-select>					
                    </div>

                    <div class="form-item form-item-width-2 pt-2 ma-0">
                        <label class="form-item-label py-0 mt-0 mr-0">上级组织:</label>
                        <v-select
                            class="form-item-value py-0 mr-0" 	
                            v-model="editingDepartment.parentOrgId"
                            :class="{readonly_input_item:parentOrgIdDisabled}"
                            :items="orgs"						
                            label=""
                            hide-details											
                            flat
                            solo
                            outlined
                            dense						                            
                            item-text="name"
                            item-value="id"
                            full-width		
                            :background-color="getSelectorBackgroundColor(parentOrgIdDisabled)"				
                        >
                        </v-select>					
                    </div>

                </div> 
				
			</v-card-text>

			<v-divider></v-divider>
			<v-card-actions>
			  <v-spacer></v-spacer>
			  
			  <v-btn
				color="success"
				class="left-round"
				@click="handleSave"
			  >			
                <span class="px-2"><v-icon>mdi-content-save-move-outline</v-icon></span>	
				保存
				
			  </v-btn>

              <v-btn
				color="blue-grey"
				class="right-round"
				@click="cancelClicked"
			  >
				
				取消
                <span class="px-2"><v-icon>mdi-file-cancel-outline</v-icon></span>
			  </v-btn>

			</v-card-actions>
		</v-card>
	</v-dialog>
	
</template>

<script>

    import DragSupport from '../../../../util/drag.js';
    import DepartmentApi from "../../../../api/smp/org/DepartmentApi.js";
    import JsonUtil from "../../../../util/JsonUtil.js";
    import OrgApi from "../../../../api/smp/org/OrgApi.js";
    import App  from "../../../../config/app.js";

	export default {
		name: 'DepartmentEditDialog',
		components: {
            
		},
		data: () => ({
			visible:false,
			mode:0, //1新增2编辑
            
            editingDepartment:{
                id:'',
                code:'',
                name:'',
                leafFlag:0,
                defaultFlag:0,
                status:-1,
                statuscaption:'',
                leafCaption:'',
                defaultCaption:'',
                operationFlag:0,
                operationCaption:'',
                orgId:-1,
                orgName:'',
                parentOrgId:-1,
                parentOrgName:'',
            },
            oriEditingDepartment:{},
            parentDepartment:{
                id:'',
                code:'',
                name:'',
            },
			brotherDepartment:{
                id:'',
                code:'',
                name:'',
            },
            orgs:[],
            options:null,
            statusFlags:[{id:'0',caption:'停用'},{id:'1',caption:'启用'}],
            leafFlags:[{id:'0',caption:'否'},{id:'1',caption:'是'}],
            defaultFlags:[{id:'0',caption:'否'},{id:'1',caption:'是'}],
            operationFlags:[{id:'0',caption:'否'},{id:'1',caption:'是'}],

            idDisabled:false,
            codeDisabled:false,
            nameDisabled:false,
            statusDisabled:false,
            leafFlagDisabled:false,
            defaultFlagDisabled:false,
            operationFlagDisabled:false,
            orgIdDisabled:false,
            parentOrgIdDisabled:false,
		}),
		methods:{
			async errMsg(title,text){
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
			async  infoMsg(title,text){
				await this.$dialog.info({
					text: text,
					title: title
				});
			},
			setVisible(v){
                this.visible=v;
                let dialogEl = this.$refs.editDialog.$refs.dialog;
                
				if(this.visible==true)
					DragSupport.bind(dialogEl,this.$refs.editDialogTitle);
				else
					DragSupport.unbind(dialogEl);    
			},
			setMode(m){
				this.mode=m;
            },
            refreshMode(){
                if(this.mode==1 || this.mode==2 || this.mode==3){
                    this.idDisabled =true;
                    this.codeDisabled=false;
                    this.nameDisabled=false;
                    this.statusDisabled=false;
                    this.leafFlagDisabled=false;
                    this.defaultFlagDisabled=false;
                    this.operationFlagDisabled=false;
                    this.orgIdDisabled=false;
                    this.parentOrgIdDisabled=false;
                }else if (this.mode==4){
                    this.idDisabled =true;
                    this.codeDisabled=true;
                    this.nameDisabled=true;
                    this.statusDisabled=false;
                    this.leafFlagDisabled=true;
                    this.defaultFlagDisabled=true;
                    this.operationFlagDisabled=true;
                    this.orgIdDisabled=true;
                    this.parentOrgIdDisabled=true;
                    this.editingDepartment.status='0';
                }
            },
            getSelectorBackgroundColor(disable){
                if(disable===true)
                    return '#e0e0e0';
                return '#ffffff';   
            },
            setOptions(options){
                this.options = options;
            },
			setParentDepartment(department){
                this.parentDepartment = this.simpleCopy(department);
            },
            setBrotherDepartment(department){
                this.brotherDepartment = this.simpleCopy(department);
            },
            setEditingDepartment(department){
                this.editingDepartment = this.simpleCopy(department);
                this.oriEditingDepartment = this.simpleCopy(department);
            },
			clear(){ 
				this.clearEditing();
            },
            clearEditing(){
                this.editingDepartment = {
                    id:'',
                    code:'',
                    name:'',
                    leafFlag:'0',
                    defaultFlag:'0',
                    status:'1',
                    statusCaption:'',
                    leafCaption:'',
                    defaultCaption:'',
                    operationFlag:'0',
                    operationCaption:'',
                    orgId:-1,
                    orgName:'',
                    parentOrgId:-1,
                    parentOrgName:'',
                };
            },
            cancelClicked(){
                this.clear();
                this.setVisible(false);
            },
			handleSave(){
                let me = this;
                
                if((!this.editingDepartment.code)||(this.editingDepartment.code=='')){
                    me.errMsg('错误','还未录入部门的编码');
                    return;
                }

                if((!this.editingDepartment.name)||(this.editingDepartment.name=='')){
                    me.errMsg('错误','还未录入名称');
                    return;
                }

                if((!this.editingDepartment.defaultFlag)||(this.editingDepartment.defaultFlag=='')||(this.editingDepartment.defaultFlag==-1)){
                    me.errMsg('错误','还未选择默认标记');
                    return;
                }

                
                if((!this.editingDepartment.leafFlag)||(this.editingDepartment.leafFlag=='')||(this.editingDepartment.leafFlag==-1)){
                    me.errMsg('错误','还未选择末级标记');
                    return;
                }

                if((!this.editingDepartment.status)||(this.editingDepartment.status=='')||(this.editingDepartment.status==-1)){
                    me.errMsg('错误','还未录入状态');
                    return;
                }

                if((!this.editingDepartment.operationFlag)||(this.editingDepartment.operationFlag=='')||(this.editingDepartment.operationFlag==-1)){
                    me.errMsg('错误','还未选择是否营运部门');
                    return;
                }


                if(this.mode==3 || this.mode==4){
                    if((!this.editingDepartment.id)||(this.editingDepartment.id=='')||(this.editingDepartment.id==-1)){
                        me.errMsg('错误','修改状态下未找到部门的编号');
                        return;
                    }
                }

                if(this.mode==1){
                    //校验与上级的代码关系
                    let parentDepartmentCode = this.parentDepartment.code;
                    let departmentCode = this.editingDepartment.code;
                    if(departmentCode.length != parentDepartmentCode.length+App.DEPT_CODE_LEVEL_LENGTH){
                        me.errMsg('错误','代码长度错误');
                        return;
                    }

                    if(departmentCode.substr(0, parentDepartmentCode.length)!=parentDepartmentCode){
                        me.errMsg('错误','代码格式必须和上级部门代码匹配');
                        return;
                    }
                }else if(this.mode==2){
                    //校验与同级的代码关系
                    let brotherDepartmentCode = this.brotherDepartment.code;
                    let departmentCode = this.editingDepartment.code;
                    if(departmentCode.length != brotherDepartmentCode.length){
                        me.errMsg('错误','代码长度错误');
                        return;
                    }

                    if(departmentCode.substr(0, brotherDepartmentCode.length-App.DEPT_CODE_LEVEL_LENGTH)!=brotherDepartmentCode.substr(0,brotherDepartmentCode.length-App.DEPT_CODE_LEVEL_LENGTH)){
                        me.errMsg('错误','代码格式必须和同级部门代码匹配');
                        return;
                    }
                }

				
				let requestData={
					mode:me.mode,
					department:{
						id:me.editingDepartment.id,
						code:me.editingDepartment.code,
						name:me.editingDepartment.name,
						status:me.editingDepartment.status,
                        leafFlag:me.editingDepartment.leafFlag,
                        defaultFlag:me.editingDepartment.defaultFlag,
                        operationFlag:me.editingDepartment.operationFlag,
                        orgId:me.editingDepartment.orgId,
                        parentOrgId:me.editingDepartment.parentOrgId,
					}
				};
				
				//开始发送请求
				DepartmentApi.persistDepartment(requestData).then(function(resp){
					console.log(resp);
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)||(!data.data)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'新增部门信息失败':msg;
						if(data.msg_detail)
							msg = msg +'('+data.msg_detail+')';
						throw new Error(msg);
						return;
					}
					
					let department = data.data.department;
					console.log("insert department finished");
					console.log(department);
					me.infoMsg('成功','新部门数据已经保存');
					me.setVisible(false);

					me.$emit("persistDepartmentFinished",me.mode,department,me.options);
				}).catch(function(err){
					console.log(err);
					me.errMsg('错误','保存部门信息可能失败，请刷新数据确认;异常信息:'+err.message);
				});
            },
            simpleCopy(department){
                let aCopy = {};
                aCopy.id = department.id;
                aCopy.code = department.code;
                aCopy.name = department.name;

                aCopy.status = department.status;
                aCopy.leafFlag = department.leafFlag;
                aCopy.defaultFlag = department.defaultFlag;
                aCopy.statusCaption = department.statusCaption;
                aCopy.leafCaption = department.leafCaption;
                aCopy.defaultCaption = department.defaultCaption;

                aCopy.orgId = department.orgId;
                aCopy.orgName = department.orgName;
                aCopy.parentOrgId = department.parentOrgId;
                aCopy.parentOrgName = department.parentOrgName;

                aCopy.operationFlag = department.operationFlag;
                aCopy.operationCaption = department.operationCaption;

                return aCopy;
            },
            loadOrgs(){
				let me = this;
				OrgApi.queryOrgs().then(function(resp){
					let data = resp.data;

					if((!data)||(!(data.code))||(data.code!=200)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取组织信息失败':msg;
						throw new Error(msg);
						return;
					}
					if((!data.data)||(!data.data.orgs)){
						throw new Error('获取组织信息失败(无组织数据)');
						return;
					}
					
					let orgs = data.data.orgs;
					
					me.orgs = JsonUtil.simpleDeepCopy(orgs);
					me.parentOrgs = JsonUtil.simpleDeepCopy(orgs);
				}).catch(function(err){
					me.errMsg('错误','获取组织信息失败:'+err.message);
				});
			},
			
			
		},
		computed:{
			title(){
				if(this.mode==1)
					return "增加下级部门";
				else if(this.mode==2)
                    return "增加同级部门";
                else if(this.mode==3)
                    return "修改部门";
                else if(this.mode==4)
                    return "部门停用";        
				else
					return "未知操作";			
			}
        },
        watch:{
            
        },
		mounted(){
			this.loadOrgs();
		}
	}
</script>

<style scoped>
	.edit-dialog{
	}
	.readonly_input_item{
		background-color:lightgrey;
	}
	.careful_input_item{
		background-color:lightblue;
	}
</style>
